// Registrar una entrada o salida de dinero con todo lo que cuelga de ella: comprobante,
// pago de deuda, gasto fijo marcado como pagado y la parte compartida en Me Deben.
// Lo usan Mis Categorías y el Registro Diario, para que las dos pantallas guarden igual.
import { supabase } from '../supabaseClient';
import { parseFecha } from './format';
import { q, crearMovimiento, recalcularDeuda } from './vinculos';
import { ivaDesdeTotal } from './iva';
import { registrarParteCompartida } from './compartido';
import { subirComprobante } from './comprobantes';

export async function registrarMovimiento({
  userId, bolsilloId, tipo, monto, descripcion, fecha,
  rubro = null, conFactura = false, presupuestoId = null,
  deuda = null, gastoFijo = null,
  compartido = null, // { persona, pct } o null
  archivo = null,
}) {
  const esEgreso = tipo === 'egreso';
  const rubroFinal = rubro || gastoFijo?.rubro || null;

  const mov = await crearMovimiento({
    userId, bolsilloId, tipo, monto, descripcion, fecha,
    gastoFijoId: gastoFijo?.id || null,
    rubro: rubroFinal,
    conFactura: esEgreso && conFactura,
    iva: ivaDesdeTotal(monto),
    // El presupuesto es solo para gastos variables: los fijos y las deudas van por su lado
    presupuestoId: (esEgreso && !deuda && !gastoFijo && presupuestoId) || null,
  });

  if (archivo) {
    await subirComprobante({
      userId, file: archivo, fecha, monto,
      concepto: descripcion || (esEgreso ? 'Salida' : 'Entrada'),
      rubro: rubroFinal, gastoFijoId: gastoFijo?.id || null, movimientoId: mov.id,
    });
  }

  // Pago de deuda → registrar en pagos_deuda vinculado a este movimiento
  if (deuda) {
    await q(supabase.from('pagos_deuda').insert({
      user_id: userId, deuda_id: deuda.id, bolsillo_id: bolsilloId, movimiento_id: mov.id,
      monto, fecha, nota: descripcion || null,
    }));
    await recalcularDeuda(deuda.id);
  }

  // Pago de gasto fijo → marcar como pagado en el mes (o año) del movimiento
  if (gastoFijo) {
    const f = parseFecha(fecha);
    await q(supabase.from('gastos_fijos').update({
      pagado: true,
      mes_pago: f.getMonth() + 1,
      ano_pago: f.getFullYear(),
      monto, // lo pagado queda como estimado del próximo período
    }).eq('id', gastoFijo.id));
  }

  // Gasto compartido → la parte de la otra persona queda en Me Deben (no mueve dinero)
  if (esEgreso && !deuda && compartido) {
    await registrarParteCompartida({
      userId, persona: compartido.persona, pct: compartido.pct, monto, fecha, descripcion,
    });
  }

  return mov;
}
